<template>
    <div>
        <v-layout wrap justify-center align-center>
            <v-flex md7 sm7 xs12>
                <dialogos-app :dialogos="dialogos" tucan="0" :adelanteVisible="mostrarAdelante" @update:currentText="currentText = $event"></dialogos-app>
            </v-flex>
        </v-layout>
        <!-- contenido de slide 1 -->
        <v-layout wrap row justify-center align-center text-xs-center class="cont_page" v-if="contSlide == 1">
          <v-flex xs12 sm7 md7>
            <v-card flat tile color="#F3D534" class="cont-drop-img">
              <v-window v-model="onboardingA" touchless>
                  <v-window-item  v-for="(dropItem, index) in dropList" :key="'item'+index">
                    <div class="cont_image">
                      <img :src="require('@/assets/unidad1/slide-8/slide-8-'+(onboardingA+1)+'.jpg')" alt="">
                    </div>
                     <!-- dropables -->
                     <div>
                      <draggable v-model="dropList[index]" @change="change($event, index)" 
                      :options="{group:'items'}" class="item-cont">
                        <p v-for="element in dropList[index]" :key="element"
                        class="item-drop"><span v-html="element"></span></p>
                      </draggable>
                     </div>
                  </v-window-item>
              </v-window>
            </v-card>
          </v-flex>
          <v-flex xs12 mt-1 v-if="mostrarBotones">
            <!-- <v-card flat tile color="transparent" class="cont-drags">
              <v-card-actions class="cont-btn-nextprev" reverse>
                <div class="btn-slide-prev hvr" fab small @click="prev">
                  <v-icon color="#5A8B34" size="40">navigate_before</v-icon>
                </div>
                <div class="btn-slide-next hvr" fab small @click="next">
                  <v-icon color="#5A8B34" size="40">navigate_next</v-icon>
                </div>
              </v-card-actions>

              <v-window v-model="onboarding"> -->
                <!-- draggables -->
                <draggable v-model="dragList" @start="saveEl" 
                class="drag-container" :options="{group:'items'}">
                  <div v-for="element in dragList" :key="element">
                    <div class="btn-blue-dark btn-drag hvr" :class="'animated bounceIn dura-'+element+''">
                      <span v-html="element"></span>
                    </div>
                  </div>
                </draggable>
              <!-- </v-window>
            </v-card> -->
          </v-flex>
          <!-- Enumeración -->
          <v-flex class="arrow" xs1>
              <img @click="onboardingA--, verFlecha=true" v-if="onboardingA>0 " 
                   class="img-arrow" :src="require('@/assets/imagenes_compartidas/Flecha_verde_izquierda.svg')" 
                   alt="Flecha Izq"
              >  
          </v-flex >
            <v-flex xs4 mt-3 class="acierto animated fadeInUp dura-2">
              <p>{{onboardingA+1}}/{{correctas.length}}</p>
            </v-flex>
          <v-flex class="arrow" xs1>
            <img  @click="onboardingA++,verFlecha=false" 
                  v-if="onboardingA<4" 
                  class="img-arrow "  
                  :src="require('@/assets/imagenes_compartidas/Flecha_verde_derecha.svg')" alt="Flecha Der"
            >  
            </v-flex > 
          <!-- ./Enumeración -->
        </v-layout>
        <!-- contenido de slide 2 -->
        <v-layout row wrap justify-center align-center text-xs-center class="cont_page" v-if="contSlide == 2">
          <button @click="openModal()" class="button-lectura" :class="{'btnexpandvisto':book}">
            <img src="@/assets/imagenes_compartidas/lectura.svg" alt="">
          </button>
        </v-layout>
        <!-- modal para segundo contenido -->
        <modal-app v-model="modal" :fullscreen="true" @click="mostrarNext()" @pausarAudio="pausarAudio(0)">
            <template slot="modaltittle">
                <span class="modal-icon-title">
                    <button class="btn-blue-dark " @click="$refs.audioPlayer.playAudio(0)">
                      <span>Clique para escutar <v-icon color="white">headset</v-icon></span>
                    </button>
                </span>
            </template>
            <v-layout row wrap>
              <v-flex xs12 md12>
              <modalslide1></modalslide1>
              </v-flex>
            </v-layout>
        </modal-app>
        <!-- modal Resultado -->
        <modal-resultado-app v-model="modalresultado" :nameResult="modalResult" :fullscreen="true" @bienAvanzar="bienAction()" @malAvanzar="malAction()">
        </modal-resultado-app>
        <audio-player ref="audioPlayer" :autoplay="false" :audios="['Lecturas/Cumprimentos']"></audio-player>
    </div>
</template>
<script>
import nextConditions from "../../js/mixins/nextConditions";
import draggable from 'vuedraggable'
import modalslide1 from '@/pages/unidad1/slide-mod8/modalslide1';
export default {
  mixins: [nextConditions],
  components: {
      draggable,
      modalslide1,
  },
  data() {
    return {
      dialogos: [
        'Relacione os cumprimentos abaixo com as imagens.',
        'Muito bem! Agora, clique no livro e leia o texto.',
        'Agora, clique em avançar.'
      ],
      numImg:1,
      length: 5,
      lengthA: 5,
      onboarding: 0,
      onboardingA: 0,
      dragList:[
        'Aperto de mão.',
        'Aceno de mão.',
        'Abraço.',
        'Tapinha nas costas.',
        'De um a três beijinhos.',
      ],
      correctas:[
        'Abraço.',
        'De um a três beijinhos.',
        'Aceno de mão.',
        'Aperto de mão.',
        'Tapinha nas costas.',
      ],
      dropList:Array(5).fill([]),
      modalresultado: false,
      modalResult:'mal',
      modal:false,
      contSlide:1,
      actualSlot:null,
      mostrarAdelante:false,
      todosCorrectos:Array(5).fill(false),
      currentText:0,
      mostrarBotones:true,
      book:false,
      verFlecha:false,
    }
  },
  created() {
        this.dragList.sort(function() {
      return 0.5 - Math.random()
    });
  },
  methods: {
      nextA () {
        this.onboardingA = this.onboardingA + 1 === this.lengthA ? 0 : this.onboardingA + 1
      },
      prevA () {
        this.onboardingA = this.onboardingA - 1 < 0 ? this.lengthA - 1 : this.onboardingA - 1
      },
      next () {
        this.onboarding = this.onboarding + 1 === this.length ? 0 : this.onboarding + 1
      },
      prev () {
        this.onboarding = this.onboarding - 1 < 0 ? this.length - 1 : this.onboarding - 1
      },
      saveEl(ev) {
      },
      change(ev, slotNum) {
        this.actualSlot = slotNum
        console.log('changed ' + ev.added.element)
        console.log('slotNum ' + slotNum)
        console.log('this.dropList '+ this.dropList)
        if(this.dropList[slotNum] == this.correctas[slotNum]){
          // this.modalresultado = true
          // this.modalResult = 'bien'
          if(this.onboardingA <= 3){
          setTimeout(() => {
            this.nextA ()
            this.prev()
            this.$set(this.todosCorrectos,this.actualSlot,true)
          }, 500);
          }else{
            this.mostrarAdelante = true
            this.mostrarBotones = false
          }
        }else{
          this.modalresultado = true
          this.modalResult = 'mal'
          this.dragList.push(ev.added.element)
          this.prev()
        }
      },
      openModal(){
      this.modal = true
      this.book = true
     // this.$refs.audioPlayer.playAudio(0);
      },
      bienAction(){

      },
      malAction(){
        this.$set(this.dropList,this.actualSlot,'')
      },
      mostrarNext(){
        this.mostrarAdelante = true
      },
      pausarAudio(){
      console.log("audio pausado")
      this.$refs.audioPlayer.pauseAudio(0)
    }
  },
  watch: {
    currentText(){
      if(this.currentText == 0){
        this.contSlide = 1
      } else  if(this.currentText == 1){
        this.contSlide = 2
        this.mostrarAdelante = false
      } else  if(this.currentText == 2){
        setTimeout(() => {
          this.$store.commit('nextShow', true);
        }, 1000);
      }
  }
  },
}
</script>
<style lang="scss" scoped>
// NOT SCOPED !!
@import '../../sass/globals';
.cont-drop-img{
  padding: 10px;
  border-radius: 10px;
  .cont_image{
    img{
      height: 150px;
      @media (min-width: 900px) {
      height: 250px;
      }
    }
  }
}
.cont-drop{
  border: 2px solid $ibra-blue;
  margin: 10px 30px;
  padding: 10px;
  p{
    margin: 0;
    padding: 0;
    color:$ibra-gray;
    font-family: Poppins-Regular;
    font-size: 12px;
  }
}

.drag-container{
  width: 100%;
  display: flex;
  flex-flow: wrap;
  justify-content: center;
  align-items: center;
}
.btn-drag{
  width: 90px;
  margin: 2px;
  padding: 3px 2px;
  text-align: center;
  font-size: 14px;
  line-height: 16px;
}
.cont-btn-nextprev{
  position: absolute;
  width: 100%;
  margin: 0 auto;
  padding: 12px;
  top: 35%;
  .btn-slide-next{
    right: 0;
    position: absolute;
    z-index: 2;
  }
  .btn-slide-prev{
    left: 0;
    position: absolute;
    z-index: 2;
  }
}
.cont-drags{
  position: relative;
}
.cont-dialogo{
  background: #81C7FD;
  padding: 10px 20px;
  border-radius: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  p{
    margin: 0;
    padding: 0;
    font-family:Poppins-Regular;
    font-size: 13px;

  }
}
.imagen-personaje-hombre{
  background: url('../../assets/unidad1/slide-6/slide-6-1.jpg')no-repeat 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: -20px;
  z-index: 1;
  width: 70px;
  height: 70px;
  background-size: 110px;
  border-radius: 50%;
}
.imagen-personaje-mujer{
  background: url('../../assets/unidad1/slide-6/slide-6-2.jpg')no-repeat 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: -20px;
  z-index: 1;
  width: 70px;
  height: 70px;
  background-size: 110px;
  border-radius: 50%;
}

.item-cont{
  border-radius: 4px;
  padding: 10px;
  background: white;
  margin: 0 auto;
  text-align: center;
  .item-drop{
    padding: 0px;
    margin: 0px;
    font-size: 15px;
    background: #FFF;
    border-radius: 4px;
    font-family: Poppins-Regular;
    span{
      color: black;
      margin: 0;
      padding: 0;
    }
  }
}
.button-lectura{
  margin-top: 15vh;
  img{
    width: 150px;
  }
}


</style>
